<template>
  <q-item :class="{ 'hovered': hovered }">
    <q-item-side>
      <q-item-tile avatar>
        <user-avatar :user="member" height="38px" width="38px"/>
      </q-item-tile>
    </q-item-side>

    <q-item-main>
      <div class="row items-center gutter-x-md q-pl-md">
        <div class="col-md-4 col-6">
          <span>
            {{ name }}
          </span>

          <q-chip v-if="member.id === user.id" class="on-right" color="positive" small>{{ $t('you') }}</q-chip>
        </div>

        <div class="col-4 gt-sm">
          <span class="text-faded">{{ member.email }}</span>
        </div>

        <div v-if="user.isAdminOf(team)" class="col-md-4 col-6 text-right team-list-entry__controls">
          <div class="row">
            <div class="col">
              <q-select
                type="radio"
                :disable="memberIsOwner"
                :options="possibleRoles"
                :value="member.role_id"
                @change="handleUpdateRole"
                @focus="hovered = true"
                @blur="hovered = false"
              />
            </div>

            <div class="col">
              <q-btn
                icon="close"
                flat
                dense
                :disabled="memberIsOwner"
                @click="handleRemoveMember"
              />
            </div>
          </div>
        </div>
      </div>
    </q-item-main>
  </q-item>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import Roles from 'src/roles'
  import UserAvatar from 'components/Common/UserAvatar.vue'
  import { createErrorFromResponse } from 'src/utils/error'
  import imageMixin from 'src/utils/mixins/image'

  export default {
    props: {
      member: {
        required: true,
        type: Object
      }
    },

    data () {
      return {
        hovered: false
      }
    },

    computed: {
      ...mapGetters(['user', 'team']),

      name () {
        return [this.member.first_name, this.member.last_name].join(' ').trim()
      },

      possibleRoles () {
        return Roles.forSelect
      },

      memberIsOwner () {
        return this.member.role_id === 0
      }
    },

    methods: {
      ...mapActions(['updateTeamMember', 'removeTeamMember']),

      handleRemoveMember () {
        this.$q.dialog({
          title: this.$t('confirm_user_delete_title'),
          message: this.$t('confirm_user_delete_body', {
            user: [this.member.first_name, this.member.last_name].join(' ').trim(),
            team: this.team.name
          }),
          ok: this.$t('confirm'),
          cancel: this.$t('abort')
        })
          .then(() => this.remove(this.member.id))
      },

      remove (id) {
        this.removeTeamMember({ team: this.team, userId: id })
          .then(() => {
            this.$q.notify({ message: this.$t('user_removed'), type: 'positive' })
          })
          .catch(createErrorFromResponse)
      },

      handleUpdateRole (role) {
        if (role > 0) {
          this.update(this.member.id, role)
        } else {
          this.$q.dialog({
            title: this.$t('confirm_user_promote_title'),
            message: this.$t('confirm_user_promote_body', {
              user: [this.member.first_name, this.member.last_name].join(' ').trim(),
              team: this.team.name
            }),
            ok: this.$t('confirm'),
            cancel: this.$t('abort')
          })
            .then(() => this.update(this.member.id, role))
        }
      },

      update (id, role) {
        this.updateTeamMember({ teamId: this.team.id, userId: id, role: role })
          .then(() => {
            this.$q.notify({ message: this.$t('permission_updated'), type: 'positive' })
          })
          .catch(createErrorFromResponse)
      }
    },

    mixins: [
      imageMixin
    ],

    components: {
      UserAvatar
    }
  }
</script>
